'use client'

import {
  Button,
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@ui/web/components'
import { typographyVariants } from '@ui/web/lib'
import cn from '@config/tailwind/cn'

import { UserNavigationButton } from '~/lib/user-navigation-button'

interface SignInModalProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  className?: string
}

export function SignInModal({ open, onOpenChange, className }: SignInModalProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        showCloseButton={false}
        className={cn('max-h-[90dvh] w-full max-w-2xl gap-4 overflow-y-auto rounded-3xl', className)}
      >
        <DialogHeader>
          <DialogTitle className={cn(typographyVariants({ variant: 'headline-sm' }), 'text-neutral-black text-center')}>
            Masuk sebagai...
          </DialogTitle>
          <DialogDescription className='sr-only'>
            Pilih salah satu opsi di bawah untuk masuk ke aplikasi PiBo.
          </DialogDescription>
        </DialogHeader>

        <section className='flex w-full flex-wrap items-center justify-center gap-4'>
          <UserNavigationButton userType='teacher' mode='signin' />
          <UserNavigationButton userType='parent' mode='signin' />
          <UserNavigationButton userType='kid' mode='signin' />
        </section>

        <div className='flex justify-center'>
          <DialogClose render={<Button variant='ghost'>Tutup</Button>} />
        </div>
      </DialogContent>
    </Dialog>
  )
}
